export enum FacetType {
  Memberships = "MembershipBodies",
  Gender = "Gender",
  Appearance = "Appearance",
  Other = "Other",
  QualificationLevels = "Qualification levels",
  EurozoneCountries = "eurozoneCountries",
  HeritageAndEthnicity = "Heritage And Ethnicity",
  EthnicBackground = "Ethnic Background",
  AgentTypes = "agentTypes",
}

export enum SkillsFacetsType {
  AccentsAndDialects = "Accents & Dialects",
  Languages = "Languages",
  MusicAndDance = "Music & Dance",
  Performance = "Performance",
  Presenting = "Presenting",
  Sports = "Sports",
  VehicleLicences = "Vehicle Licences",
  VoiceOver = "Voice Over",
  OtherSkills = "Other Skills",
}

export enum SkillFacetNames {
  AccentsAndDialects = "accentsAndDialects",
  Languages = "languages",
  MusicAndDance = "musicAndDance",
  Performance = "performances",
  Presenting = "presenting",
  Sports = "sports",
  VehicleLicences = "vehicleLicences",
  VoiceOver = "voiceOver",
  OtherSkills = "otherSkills",
}

export enum FacetCategory {
  ProductionType = "Production type",
  ContractType = "Contract types",
  ComplaintCategory = "Complaint categories",
  MembershipBodies = "Membership Bodies",
  FacialHair = "Facial Hair",
  VoiceStyle = "Voice Style",
  Appearance = "Appearance",
  HairColour = "Hair Colour",
  EyeColour = "Eye Colour",
  HairLength = "Hair Length",
  Nationality = "Nationality",
  BeltNotes = "Belt Notes",
  Disability = "Disability",
  Gender = "Gender",
  HeritageAndEthnicity = "Heritage And Ethnicity",
  EthnicBackground = "Ethnic Background",
  VisasAndWorkingPermits = "Visas & Working Permits",
}

export type IGetFacetsResponse = IFacetResponse[];

export interface IFacetLevel {
  id: number;
  maxActiveCount: number;
  name: string;
  position: number;
}

export interface IFacetResponse {
  id: number;
  name: string;
  code: string;
  systemName: string;
  maxActiveCount: number;
  facetGroups: IFacetGroup[];
  facetLevels: IFacetLevel[];
}

export interface IFacetGroup {
  id: number;
  name: string;
  code: string;
  facets: IFacet[];
}

export interface IFacet {
  id: number;
  name: string;
  code: string;
  orderKey?: number | null;
}

export interface ISkillFacet extends IFacet {
  facetLevels: IFacetLevel[];
}
